<template>
  <div class="">
    <div
      class="modal fade"
      ref="modal"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="addRecordLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header chat-header py-1" ref="modalHeader">
            <h5 class="modal-title text-white"></h5>
            <button
              type="button"
              class="close-btn d-flex justify-content-center align-items-center"
              data-dismiss="modal"
              aria-label="Close"
              @click="cancel"
            >
              <Icon icon="grommet-icons:down" style="font-size: 16px" />
            </button>
            <div
              class="p-1 d-flex align-items-center justify-content-center text-center bg-white chat-loader2"
              v-if="loading2"
            >
              <div
                class="spinner-border spinner-border-sm text-secondary"
                role="status"
              ></div>
            </div>
          </div>
          <div
            class="modal-body chat-container overflow-y-auto p-0 d-flex flex-column"
            ref="chat"
            @scroll="handleScrollTop"
          >
            <div class="py-2 text-center" v-if="loading || !noMoreMessages">
              <div
                class="spinner-border spinner-border-sm text-secondary"
                role="status"
              ></div>
            </div>
            <div class="flex-grow-1 mx-1" v-if="msgArr && msgArr.length">
              <div v-for="(item, index) in msgArr" :key="item.id">
                <div
                  class="text-sm py-2 text-secondary text-center"
                  style="font-size: 12px"
                  v-if="
                    index === 0 ||
                    formatDate(item.createdAt) !==
                      formatDate(msgArr[index - 1].createdAt)
                  "
                >
                  {{ formatDate(item.createdAt) }}
                </div>
                <div
                  class="d-flex my-1 px-2"
                  :class="
                    item.sender == 'User'
                      ? 'justify-content-end'
                      : 'justify-content-start'
                  "
                >
                  <div
                    class="chat-message px-2 py-1 mb-1"
                    :class="
                      item.sender == 'User'
                        ? 'user-chat text-white'
                        : 'bg-light text-dark bot-chat'
                    "
                  >
                    <div class="text-break" v-if="item.type === 'TEXT'">
                      {{ item.message }}
                      <div
                        class="mt-2"
                        v-if="item.choices && item.choices.length"
                      >
                        <div
                          v-for="(choice, index) in item.choices"
                          :key="index"
                        >
                          <button
                            type="button"
                            @click.prevent="handleChoice(choice, item.id)"
                            :class="choicesId.includes(item.id) ? 'd-none' : ''"
                            class="chat-choice-btn px-3 py-1 text-break"
                            :style="
                              index === item.choices.length - 1
                                ? ''
                                : { marginBottom: '8px' }
                            "
                          >
                            {{ choice }}
                          </button>
                        </div>
                      </div>

                      <p
                        class="d-flex justify-content-end mb-0 pt-2 chat-time"
                        :class="
                          item.sender == 'User'
                            ? ' text-white'
                            : 'text-secondary'
                        "
                      >
                        {{ item.sender !== "User" ? `${item.sender} -` : "" }}
                        {{ formatTime(item.createdAt) }}
                      </p>
                    </div>
                    <div
                      v-else-if="item.type === 'FILE'"
                      class=""
                      @click="viewImage(item.message)"
                    >
                      <img
                        class="img-fluid rounded chat-img"
                        :src="item.message"
                        alt=""
                        loading="lazy"
                      />
                      <p
                        class="d-flex justify-content-end mb-0 pt-2 chat-time"
                        :class="
                          item.sender === 'User' ? ' text-white' : 'text-dark'
                        "
                      >
                        {{ item.sender !== "User" ? `${item.sender} -` : "" }}
                        {{ formatTime(item.createdAt) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer px-1 py-2 justify-content-start">
            <div class="row m-0 flex-grow-1">
              <div class="col-12" v-if="image">
                <div class="pt-2 pb-3 chat-img-container">
                  <img
                    class="rounded-lg img-fluid"
                    :src="display"
                    alt="image"
                    width="40"
                    height="40"
                  />
                  <div
                    @click="removeImg"
                    class="rounded-circle close-img px-2 py-1 text-dark bg-light"
                  >
                    &#10005;
                  </div>
                </div>
              </div>
              <div
                class="col-12 d-flex align-items-center justify-content-center"
              >
                <div>
                  <div @click.prevent="clickFile()" class="">
                    <Icon
                      class="chat-attach-icon"
                      icon="simple-line-icons:paper-clip"
                      style="font-size: 18px; cursor: pointer; color: gray"
                    />
                  </div>
                  <input
                    @input.prevent="attachFile($event)"
                    type="file"
                    class="d-none"
                    ref="fileInput"
                    accept="image/*"
                  />
                </div>
                <div class="px-2 chat-input-container" @keyup.enter="sendMsg">
                  <Textarea
                    v-model="msg"
                    :autoResize="true"
                    rows="1"
                    cols="30"
                    class="form-control"
                  />
                </div>
                <button type="button" class="chat-send-btn" @click="sendMsg">
                  <Icon icon="fe:paper-plane" style="font-size: 24px" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <toast-component ref="toastRef"></toast-component>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import Textarea from "primevue/textarea";
import { Icon } from "@iconify/vue2";
import ToastComponent from "../../components/ToastComponent.vue";
import ShareableMethods from "../../mixins/ShareableMethods";
export default {
  props: {
    handleChat: {
      type: Function,
      default: () => {},
    },
  },
  mixins: [ShareableMethods],
  components: {
    ToastComponent,
    Icon,
    Textarea,
  },
  data() {
    return {
      resolve: null,
      reject: null,
      modal: null,
      accountNumber: "",
      msg: "",
      msgArr: [],
      lastId: null,
      display: null,
      image: null,
      errMsg: "",
      loading: false,
      loading2: false,
      noMoreMessages: false,
      // wsDomain: "ws://192.168.100.38:8087",
      wsDomain: "wss://chat-api.s2s.ph",
      ws: null,
      reconnecting: false,
    };
  },
  methods: {
    async open() {
      this.msgArr.splice(0, this.msgArr.length);
      this.noMoreMessages = false;
      this.loading = false;
      this.loading2 = false;

      await this.modal.show();
      await this.resetSocket();
      document.body.classList.remove("modal-open");

      await this.handleStart();
      await this.openSocket();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel() {
      if (document.activeElement) {
        document.activeElement.blur();
      }

      this.handleChat(false);

      if (typeof this.resolve === "function") {
        this.resolve(false);
      }

      this.modal.hide();
    },
    async handleStart() {
      this.accountNumber = "";
      this.loading = true;
      const accountStored = localStorage.getItem("S2SChatAccount");
      if (accountStored) {
        this.loading = false;
        this.accountNumber = accountStored;

        return;
      }

      try {
        const response = await this.$chat.post("/chat-account");
        const { status, data } = response.data;

        if (!status) return;

        this.accountNumber = data?.accountNumber;
        localStorage.setItem("S2SChatAccount", this.accountNumber);
      } catch (err) {
        this.$refs.toastRef.open(
          { message: err.message || err },
          { bgClass: "bg-danger" }
        );
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async resetSocket() {
      if (this.ws) {
        this.ws.close();
        this.ws = null;
      }
    },

    sendSocketMessage(payload) {
      if (!this.ws) return;

      const message = JSON.stringify(payload);

      if (this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(message);
        return;
      }

      if (this.ws.readyState === WebSocket.CONNECTING) {
        this.ws.addEventListener(
          "open",
          () => {
            this.ws.send(message);
          },
          { once: true }
        );
      }
    },

    async openSocket() {
      if (
        this.ws &&
        (this.ws.readyState === WebSocket.OPEN ||
          this.ws.readyState === WebSocket.CONNECTING)
      ) {
        return;
      }

      this.ws = new WebSocket(this.wsDomain);

      await new Promise((resolve) => {
        this.ws.addEventListener(
          "open",
          () => {
            this.sendSocketMessage({
              type: "START",
              accountNumber: this.accountNumber,
            });

            resolve();
          },
          { once: true }
        );
        this.ws.addEventListener("message", this.handleMessage);

        this.ws.addEventListener("close", async () => {
          console.warn("WebSocket Closed");

          if (this.reconnecting) return;

          this.reconnecting = true;

          setTimeout(async () => {
            try {
              await this.openSocket();
            } finally {
              this.reconnecting = false;
            }
          }, 1000);
        });

        this.ws.addEventListener("error", (err) => {
          this.noMoreMessages = true;
          this.loading2 = false;
          this.loading = false;
          console.error(err);
          this.$refs.toastRef.open(
            { message: "Unable to connect to chat server" },
            { bgClass: "bg-danger" }
          );
          this.ws.close();
        });
      });
    },
    handleMessage({ data }) {
      const response = JSON.parse(data);
      console.log(response);

      if (response.type === "MESSAGE") {
        const messageData = response.data;
        if (messageData?.message.includes("Welcome to")) {
          this.noMoreMessages = true;
        }

        this.msgArr.push(messageData);
        this.$nextTick(() => {
          this.msg = "";
          this.image = null;
          this.loading2 = false;
          this.scrollToBottom();
        });
      }

      if (response.type === "LIST") {
        const mess = [...response.data];
        const chat = this.$refs.chat;
        const previousScrollHeight = chat.scrollHeight;

        if (mess.length <= 1) {
          this.noMoreMessages = true;
        }

        if (this.lastId) {
          this.msgArr = [...mess.reverse(), ...this.msgArr];
        } else {
          this.msgArr = [...mess.reverse()];
        }

        this.$nextTick(() => {
          requestAnimationFrame(() => {
            const newScrollHeight = chat.scrollHeight;
            if (this.lastId) {
              const scrollDifference = newScrollHeight - previousScrollHeight;
              chat.scrollTop += scrollDifference;
            } else {
              this.scrollToBottom();
            }
          });
        });

        this.$nextTick(() => {
          if (chat.scrollHeight <= chat.clientHeight && !this.noMoreMessages) {
            const lastId = this.msgArr[0]?.id;
            if (this.lastId !== lastId) {
              this.lastId = lastId;

              this.sendSocketMessage({
                type: "LIST",
                accountNumber: this.accountNumber,
                lastId: this.lastId,
              });
            }
          }
        });
      }

      if (response.type === "ERROR") {
        const error = response.message;
        this.$refs.toastRef.open({ message: error }, { bgClass: "bg-danger" });
        if (error === "Account not found" || error === "Not allowed") {
          localStorage.setItem("S2SChatAccount", "");
          this.$refs.toastRef.open(
            {
              message:
                "Session not found. Please refresh the page to get a new session.",
            },
            { bgClass: "bg-danger" }
          );
        }
      }
    },
    viewImage(image) {
      const index = this.images.findIndex((item) => item === image);

      this.$viewerApi({
        options: { initialViewIndex: index },
        images: this.images,
      });
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const chat = this.$refs.chat;
        chat.scrollTop = chat.scrollHeight;
      });
    },
    handleScrollTop() {
      const chat = this.$refs.chat;
      if (chat.scrollTop === 0 && this.msgArr.length && !this.noMoreMessages) {
        const lastId = this.msgArr[0]?.id;

        if (this.lastId !== lastId) {
          this.lastId = lastId;
          const payload = {
            type: "LIST",
            accountNumber: this.accountNumber,
            lastId: this.lastId,
          };

          this.sendSocketMessage(payload);
        }
      }
    },
    handleChoice(choices, id) {
      this.msg = choices;
      this.sendMsg();
      this.$store.commit("setChoicesId", id);
    },
    clickFile() {
      this.$refs.fileInput.click();
    },
    attachFile(e) {
      this.image = e.target.files[0];
      this.$refs.fileInput.value = null;

      if (this.image) {
        const reader = new FileReader();
        reader.readAsDataURL(this.image);

        reader.onload = () => {
          this.display = reader.result;
        };
      }
    },
    handleDraggable() {
      const modal = this.$refs.modal?.querySelector(".modal-dialog");
      const header = this.$refs.modalHeader;

      if (!modal || !header) return;

      const isMobile = window.innerWidth <= 768;

      modal.style.position = "fixed";
      modal.style.transform = "none";
      modal.style.width = "100%";
      modal.style.margin = "0px";

      modal.style.top = "auto";
      modal.style.left = "";
      modal.style.right = "";
      modal.style.bottom = "";

      if (isMobile) {
        modal.style.maxWidth = "100%";
        modal.style.bottom = "0px";
        modal.style.left = "0px";
        modal.style.right = "0px";
      } else {
        modal.style.maxWidth = "375px";
        modal.style.bottom = "18px";
        modal.style.left = "auto";
        modal.style.right = "24px";
      }

      let isDragging = false;
      let offsetX = 0;
      let offsetY = 0;

      if (!isMobile) {
        header.style.cursor = "move";

        header.onmousedown = (e) => {
          isDragging = true;

          const rect = modal.getBoundingClientRect();

          offsetX = e.clientX - rect.left;
          offsetY = e.clientY - rect.top;

          document.onmousemove = (e) => {
            if (!isDragging) return;

            let newLeft = e.clientX - offsetX;
            let newTop = e.clientY - offsetY;

            const minLeft = 0;
            const maxLeft = window.innerWidth - modal.offsetWidth;

            const minTop = window.innerHeight * 0.2;
            const maxTop = window.innerHeight - modal.offsetHeight;

            newLeft = Math.min(Math.max(newLeft, minLeft), maxLeft);

            newTop = Math.min(Math.max(newTop, minTop), maxTop);

            modal.style.left = `${newLeft}px`;
            modal.style.top = `${newTop}px`;
          };

          document.onmouseup = () => {
            isDragging = false;
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    },
    handleOutsideClick(e) {
      if (e.target === this.$refs.modal) {
        this.cancel();
      }
    },
    removeImg() {
      this.image = null;
      this.$refs.fileInput.value = null;
      this.display = null;
    },
    sendMsg() {
      if (!this.image && !this.msg) {
        return;
      }

      if (this.image) {
        const reader = new FileReader();

        reader.onloadend = () => {
          let imageBase64 = reader.result;

          this.sendSocketMessage({
            type: "MESSAGE",
            image: imageBase64,
            accountNumber: this.accountNumber,
            message: this.msg.trim(),
          });

          this.image = null;
          this.loading2 = true;
          this.$refs.fileInput.value = null;
        };
        reader.readAsDataURL(this.image);
      } else {
        this.sendSocketMessage({
          type: "MESSAGE",
          accountNumber: this.accountNumber,
          message: this.msg.trim(),
        });
      }
      this.$nextTick(() => {
        this.msg = "";
      });
    },
    lockScroll() {
      document.addEventListener("wheel", this.preventBodyScroll, {
        passive: false,
      });
      document.addEventListener("touchmove", this.preventBodyScroll, {
        passive: false,
      });
    },
    unlockScroll() {
      document.removeEventListener("wheel", this.preventBodyScroll);
      document.removeEventListener("touchmove", this.preventBodyScroll);
    },
    preventBodyScroll(e) {
      const chat = this.$refs.chat;
      const { scrollTop, scrollHeight, clientHeight } = chat;

      const isAtTop = scrollTop === 0;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight;

      const isScrollingUp = e.deltaY < 0;
      const isScrollingDown = e.deltaY > 0;

      if ((isAtTop && isScrollingUp) || (isAtBottom && isScrollingDown)) {
        e.preventDefault();
      }
    },
  },
  mounted() {
    this.modal = new Modal(this.$refs.modal, {
      keyboard: false,
      backdrop: false,
    });
    this.handleDraggable();
    const chat = this.$refs.chat;

    chat.addEventListener("mouseenter", this.lockScroll);
    chat.addEventListener("mouseleave", this.unlockScroll);
    if (this.$refs.modal) {
      this.$refs.modal.addEventListener("click", this.handleOutsideClick);
    }

    window.addEventListener("resize", () => {
      this.handleDraggable();
    });
  },
  beforeUnmount() {
    if (document.activeElement) {
      document.activeElement.blur();
    }

    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  },

  computed: {
    images() {
      if (this.msgArr.length) {
        const images = this.msgArr
          .filter((item) => item.type === "FILE")
          .map((item) => item.message);
        return images;
      }
      return [];
    },
    choicesId() {
      console.log("choices", this.$store.getters.choicesId);
      return this.$store.getters.choicesId;
    },
  },
};
</script>

<style scoped lang="scss">
textarea {
  max-height: 20px;
  resize: none;
}
textarea:focus {
  border-color: rgb(146, 146, 146);
  box-shadow: none;
  max-height: 75px;
  outline: none;
}

.chat {
  &-header {
    background-color: #ff7200;
    height: 48px;
    position: relative;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  &-container {
    height: 400px;
    overflow-y: auto;
  }
  &-img {
    max-width: 100%;
    max-height: 250px;
    cursor: pointer;
  }
  &-message {
    border-radius: 8px;
    font-smooth: always;
    font-family: "Lato", sans-serif;
    font-size: 14px;
    max-width: 50%;
  }
  &-input-container {
    width: 100%;
  }
  &-img-container {
    position: relative;
    left: 30px;
  }
  &-time {
    font-size: 10px;
  }
  &-choice-btn {
    width: 100%;
    outline: none;
    border: none;
    color: white;
    background-color: #ff7200;
    border-radius: 4px;

    padding: 3px 0;
    &:hover {
      background-color: #f36b02;
    }
  }
  &-content {
    position: relative;
  }
  &-loader2 {
    position: absolute;
    border-radius: 50%;
    top: 55px;
    left: 47.5%;
    z-index: 9999;
  }
  &-send-btn {
    outline: none;
    border: none;
    color: #ff7200;
    background-color: transparent;
    &:hover {
      color: #f66700;
    }
  }
  &-attach-icon {
    &:hover {
      color: #333232 !important;
    }
  }
}

.modal-content {
  border: none;
  border-radius: 10px;
}

@media (max-width: 768px) {
  .modal-dialog {
    max-width: 100% !important;
    width: 100% !important;
    height: 65vh !important;
  }

  .modal-content {
    border-radius: 0;
    height: 100% !important;
  }

  .chat {
    &-header {
      border-radius: 0;
    }
    &-container {
      min-height: 0;
    }
  }
}

.user-chat {
  background-color: #ff7200;
  // background-image: linear-gradient(to bottom right, #ff7200, #f59f0b);
}

.close-btn {
  border: none;
  outline: none;
  color: #edebeb;
  right: 0px;
  top: -45px;
  border-radius: 50%;
  position: absolute;
  padding: 10px;
  background-color: #ff7200;
}
.close-btn:hover {
  background-color: #f66700;
}
.close-img {
  top: -6px;
  left: 50px;
  cursor: pointer;
  position: absolute;
  font-size: 9px;
}
.close-img:hover {
  background-color: #9d9d9d !important;
  color: #fff !important;
}
</style>
